var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmployeeInfoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1397_22070)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.28361 7.32072H5.44529V6.68823C5.44529 6.39714 5.68127 6.16116 5.97236 6.16116H8.07933C8.37041 6.16116 8.6064 6.39714 8.6064 6.68823V7.32072H8.86969C9.89369 7.32072 10.8684 6.88082 11.5458 6.11288L13.8859 3.24675C13.6304 2.7164 13.0875 2.34956 12.4604 2.34956H9.70444V1.61854C9.70448 0.726063 8.97841 0 8.0859 0H5.96579C5.07335 0 4.34725 0.726063 4.34725 1.61854V2.34956H1.59128C0.998809 2.34956 0.481714 2.67726 0.210938 3.16076L2.59715 6.101C3.27476 6.87608 4.2541 7.32072 5.28361 7.32072ZM5.40143 1.61854C5.40143 1.30736 5.6546 1.05415 5.96579 1.05415H8.0859C8.39708 1.05415 8.65029 1.30736 8.65029 1.61854V2.34956H5.4014V1.61854H5.40143Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.5 7.21484H7.55285V8.26899H6.5V7.21484Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0175 13.0121C10.2825 11.7192 10.4435 10.0502 11.5014 8.92253C12.1652 8.21506 13.0643 7.82545 14.0334 7.82545C14.0367 7.82545 14.04 7.82555 14.0433 7.82559V4.72259L12.3512 6.79501L12.338 6.81009C11.4608 7.80443 10.1973 8.37473 8.87132 8.37473H8.60807V8.79639C8.60807 9.08747 8.37208 9.32346 8.08099 9.32346H5.97403C5.68294 9.32346 5.44695 9.08747 5.44695 8.79639V8.37473H5.28528C3.9515 8.37473 2.68304 7.79885 1.80518 6.79473L1.79246 6.78019L0.0117188 4.58594V12.4229C0.0117188 13.2948 0.721056 14.0041 1.59294 14.0041H10.029C10.3106 13.6292 10.6437 13.2951 11.0175 13.0121Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3958 13.8381C15.7524 14.4379 14.9228 14.7656 14.0343 14.7657H14.0341C13.1594 14.7657 12.3118 14.43 11.6728 13.8379C10.7078 14.5592 10.082 15.7104 10.082 17.0052V17.5194C10.082 17.7847 10.297 17.9997 10.5623 17.9997H17.5061C17.7713 17.9997 17.9863 17.7847 17.9863 17.5194V17.0052C17.9863 15.7106 17.3606 14.5594 16.3958 13.8381Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2689 9.64306C11.3999 10.5693 11.3999 12.0206 12.2689 12.9468C12.7245 13.4325 13.3672 13.711 14.0321 13.711H14.0322C14.7068 13.711 15.333 13.4396 15.7953 12.9468C16.6643 12.0206 16.6643 10.5693 15.7953 9.64306C15.3329 9.15028 14.7068 8.87891 14.0321 8.87891C13.3574 8.87887 12.7312 9.15024 12.2689 9.64306Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1397_22070"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmployeeInfoIcon);
export default __webpack_public_path__ + "static/media/employee-info-icon.88f15b1d3931b85bcd6b700e978ae4a2.svg";
export { ForwardRef as ReactComponent };